import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useChatSidebar } from './GlobalChatSidebar/ChatSidebarProvider';
import DisasterChatManager from './DisasterGPT/DisasterChatManager';
import AiDrawer from './DisasterGPT/chatV2/AiDrawer';
import { StylishNewButton } from './DesignSystems/New/StylishNewButton';
import { SharedIcon } from './SharedIcon/SharedIcon';
import { useAiChatV2Flag } from '../utils/featureFlags';
import './GlobalChatSidebar.scss';

/**
 * Legacy fixed-width shell. Kept as the fallback until the Playwright chat
 * specs pass against the V2 drawer and `AI_CHAT_V2` becomes the default.
 */
const LegacyChatSidebar: React.FC = () => {
  const { isVisible, hide } = useChatSidebar();

  const sidebarClasses = classNames('global-chat-sidebar', {
    'global-chat-sidebar--visible': isVisible,
    'global-chat-sidebar--hidden': !isVisible,
  });

  return (
    <div className={sidebarClasses}>
      <div className="sidebar-content-wide d-flex flex-column h-100">
        <div className="sidebar-title">
          <h4 className="m-0">PRATUS AI Chat</h4>
          <StylishNewButton
            customButton
            className="button--icon"
            onClick={hide}
          >
            <SharedIcon iconName="close" />
          </StylishNewButton>
        </div>
        <div className="sidebar-content-wrapper">
          <DisasterChatManager selectedDatetime={new Date().toISOString()} />
        </div>
      </div>
    </div>
  );
};

const GlobalChatSidebar: React.FC = () => {
  const v2 = useAiChatV2Flag();
  const { isVisible, hide } = useChatSidebar();
  // Legacy passes "now" on every render; V2 fixes it per open so the value
  // sent with each message is stable for the session.
  const selectedDatetime = useMemo(
    () => (isVisible ? new Date().toISOString() : undefined),
    [isVisible]
  );

  if (v2) {
    return (
      <AiDrawer
        open={isVisible}
        onClose={hide}
        selectedDatetime={selectedDatetime}
      />
    );
  }
  return <LegacyChatSidebar />;
};

export default GlobalChatSidebar;
